/* eslint-disable react/forbid-dom-props */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from '@shared/components/spzaComponent';
import { Constants } from '@shared/utils/constants';
import PaginationControl from '@shared/components/paginationControl';
import { getWindow } from '@shared/services/window';
import { shouldShowPowerAppsNoContent, getPowerAppsTitle } from '../../embed/embedHostUtils';
import { getFilteredAppPageTitle } from '@shared/utils/localization';
import { DataMap } from '@shared/utils/dataMapping';
import { urlPush, routes } from '@shared/routerHistory';
import Animation from '@shared/components/animation';
import { getEntityRegistration } from '@shared/utils/entityRegistration';
import { NoSearchResults } from '@shared/components/noSearchResults';
import { logger } from '@src/logger';
import powerApps from '@shared/images/powerApps.png';
import { getProductByUrlKey } from '@shared/utils/appUtils';
class AppSourceFilteredGallery extends SpzaComponent {
    componentDidMount() {
        var _getWindow_location, _getWindow;
        const { isConverged } = this.props;
        const perfPayload = {
            page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href,
            action: Constants.Telemetry.Action.PageLoad,
            actionModifier: Constants.Telemetry.ActionModifier.End
        };
        logger.info('', {
            action: perfPayload.action,
            actionModifier: perfPayload.actionModifier
        });
        document.getElementsByTagName('title')[0].innerHTML = getFilteredAppPageTitle({
            context: this.context,
            isConverged
        });
    }
    setPageSize() {
        this.filteredData = [];
        this.galleryPage = this.props.galleryPage ? this.props.galleryPage : 1;
        // todo: validate rendering second page of tiles and validate props being passed into pagination control
        const pageSize = this.props.pageSize ? this.props.pageSize : this.defaultPageSize;
        this.maxPages = Math.ceil(this.props.count / pageSize);
        this.filteredData = this.props.filteredData.slice();
    }
    setMaxPages(itemCount, pageSize) {
        this.maxPages = Math.ceil(itemCount / pageSize);
        if (this.galleryPage > this.maxPages) {
            this.galleryPage = this.maxPages;
        }
    }
    getTiles() {
        const entityRegistration = getEntityRegistration(this.props.entityType);
        const TileType = entityRegistration.tileType;
        return /*#__PURE__*/ _jsx("div", {
            className: "spza_filteredTileContainer",
            children: this.filteredData.map((entity, index)=>{
                return /*#__PURE__*/ _createElement(TileType, _object_spread_props(_object_spread({}, entity), {
                    item: entity,
                    key: entity.entityId,
                    tileIndex: index,
                    totalTiles: this.filteredData.length,
                    selectedLocale: this.props.selectedLocale,
                    embedHost: this.props.embedHost,
                    countryContext: this.props.selectedCountry,
                    ribbonKey: 'FilteredGallery_AllResults',
                    isPrivateOffer: this.props.showPrivateApps
                }));
            })
        });
    }
    logNoContentTelemetry(link, linkType) {
        var _getProductByUrlKey;
        const details = {
            linkType,
            link,
            tab: 'Default'
        };
        const payload = {
            page: 'In App Gallery(' + ((_getProductByUrlKey = getProductByUrlKey({
                urlKey: this.props.embedHost
            })) === null || _getProductByUrlKey === void 0 ? void 0 : _getProductByUrlKey.UrlKey) + ')',
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.Link,
            details: JSON.stringify(details)
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    }
    logAndNavigate(link, linkType) {
        this.logNoContentTelemetry(link, linkType);
        urlPush(link);
    }
    getNoContentUI() {
        // We have 3 cases for 'No Content' UIs
        // 1) Apps tab for all products
        // 2) My Org tab for only power-bi
        // 3) My Org tab for dynamics-365
        const publicGalleryUri = this.context.buildHref(routes.marketplace, null, {
            showPrivateApps: 'false',
            page: '1'
        });
        const privateGalleryUri = this.context.buildHref(routes.marketplace, null, {
            showPrivateApps: 'true',
            page: '1'
        });
        // This is No Content UI for Apps tab
        if (!this.props.showPrivateApps) {
            return /*#__PURE__*/ _jsxs("div", {
                className: "noOrgContent",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: this.props.searchText ? this.context.loc('Search_NoApps') : this.context.loc('FilteredGallery_NoApps')
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: this.props.searchText ? this.props.privateAppsCount ? /*#__PURE__*/ _jsx("span", {
                            className: "switchPage",
                            onClick: ()=>{
                                this.logAndNavigate(privateGalleryUri, 'SwitchTo_MyOrg');
                            },
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML: {
                                __html: this.context.locParams('Search_SwitchTab', [
                                    '<span>' + this.context.loc('Embedded_MyOrganization') + '</span>',
                                    this.props.privateAppsCount.toString()
                                ])
                            }
                        }) : /*#__PURE__*/ _jsx("span", {
                            className: "switchPage",
                            onClick: ()=>{
                                this.logNoContentTelemetry('"https://appsource.microsoft.com/en-us/marketplace/apps?search=' + encodeURIComponent(this.props.searchText) + '&page=1"', 'AppsTab_SwitchTo_Appsource');
                            },
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML: {
                                __html: this.context.locParams('Search_SimilarApps', [
                                    '<a href="https://appsource.microsoft.com/en-us/marketplace/apps?search=' + encodeURIComponent(this.props.searchText) + '&page=1" target="_blank">Appsource.com</a>'
                                ])
                            }
                        }) : null
                    })
                ]
            });
        }
        // This is No Content UI for Power BI My Org tab
        if (this.props.embedHost === DataMap.products.PowerBI.UrlKey) {
            return /*#__PURE__*/ _jsxs("div", {
                className: "noOrgContent",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: this.props.searchText ? this.props.publicAppsCount ? /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    children: this.context.loc('Search_NoApps')
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "switchPage shiftLeft",
                                    onClick: ()=>{
                                        this.logAndNavigate(publicGalleryUri, 'SwitchTo_Apps');
                                    },
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML: {
                                        __html: this.context.locParams('Search_SwitchTab', [
                                            '<span>' + this.context.loc('Embedded_Apps') + '</span>',
                                            this.props.publicAppsCount.toString()
                                        ])
                                    }
                                })
                            ]
                        }) : /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    children: this.context.loc('Search_NoApps')
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "switchPage shiftLeft",
                                    onClick: ()=>{
                                        this.logNoContentTelemetry('"https://appsource.microsoft.com/en-us/marketplace/apps?search=' + encodeURIComponent(this.props.searchText) + '&page=1"', 'MyOrgTab_SwitchTo_Appsource');
                                    },
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML: {
                                        __html: this.context.locParams('Search_SimilarApps', [
                                            '<a href="https://appsource.microsoft.com/en-us/marketplace/apps?search=' + encodeURIComponent(this.props.searchText) + '&page=1" target="_blank">Appsource.com</a>'
                                        ])
                                    }
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx("div", {
                            children: this.context.loc('Embedded_No_MyOrg_Content_PowerBI')
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "powerAppsCreate",
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: this.context.locParams('Embedded_PowerBI_Create_Link', [
                                '<a href="https://powerbi.microsoft.com/en-us/documentation/powerbi-service-organizational-content-pack-tutorial-create-and-publish/" target="_blank">' + this.context.loc('Embedded_PowerBI_Create_Link_Learn_Link_Text') + '</a>'
                            ])
                        },
                        onClick: ()=>{
                            this.logNoContentTelemetry('https://powerbi.microsoft.com/en-us/documentation/powerbi-service-organizational-content-pack-tutorial-create-and-publish/', 'pbi_CreateContentPacks');
                        }
                    })
                ]
            });
        } else {
            // This is No Content UI for Dynamics-365 My Org tab
            return /*#__PURE__*/ _jsxs("div", {
                className: "noOrgContent",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: this.props.searchText ? this.context.loc('Search_NoApps') : null
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: this.props.searchText ? this.props.publicAppsCount ? /*#__PURE__*/ _jsx("span", {
                            className: "switchPage",
                            onClick: ()=>{
                                this.logAndNavigate(publicGalleryUri, 'SwitchTo_Apps');
                            },
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML: {
                                __html: this.context.locParams('Search_SwitchTab', [
                                    '<span>' + this.context.loc('Embedded_Apps') + '</span>',
                                    this.props.publicAppsCount.toString()
                                ])
                            }
                        }) : /*#__PURE__*/ _jsx("span", {
                            className: "switchPage",
                            onClick: ()=>{
                                this.logNoContentTelemetry('"https://appsource.microsoft.com/en-us/marketplace/apps?search=' + encodeURIComponent(this.props.searchText) + '&page=1"', 'MyOrgTab_SwitchTo_Appsource');
                            },
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML: {
                                __html: this.context.locParams('Search_SimilarApps', [
                                    '<a href="https://appsource.microsoft.com/en-us/marketplace/apps?search=' + encodeURIComponent(this.props.searchText) + '&page=1" target="_blank">Appsource.com</a>'
                                ])
                            }
                        }) : /*#__PURE__*/ _jsx("div", {
                            children: this.props.partnerAppDataLoadedError ? this.context.loc('Embedded_No_MyOrg_Content_Error') : this.context.loc('Embedded_No_MyOrg_Content_PowerBI')
                        })
                    }),
                    this.props.partnerAppDataLoadedError ? null : /*#__PURE__*/ _jsx("div", {
                        className: "actions",
                        children: /*#__PURE__*/ _jsxs("a", {
                            className: "action powerApps",
                            href: "https://web.powerapps.com/",
                            rel: "noreferrer",
                            target: "_blank",
                            onClick: ()=>{
                                this.logNoContentTelemetry('https://web.powerapps.com/', 'powerApps_Create');
                            },
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "title",
                                    children: this.context.loc('Embedded_No_MyOrg_Content_Action2_Title')
                                }),
                                /*#__PURE__*/ _jsx("img", {
                                    src: powerApps
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "bottom c-glyph",
                                    children: getPowerAppsTitle()
                                })
                            ]
                        })
                    })
                ]
            });
        }
    }
    renderImpl() {
        var _this_filteredData;
        const { query, entityType, partnerAppDataLoaded, showPrivateApps, isEmbedded, embedHost } = this.props;
        this.setPageSize();
        if (isEmbedded && shouldShowPowerAppsNoContent(embedHost) && showPrivateApps && !this.filteredData.length) {
            const context = this.context;
            if (partnerAppDataLoaded) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "filteredGalleryContainer",
                    children: this.getNoContentUI()
                });
            } else {
                return /*#__PURE__*/ _jsx("div", {
                    className: "filteredGalleryContainer",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "loader",
                        children: [
                            /*#__PURE__*/ _jsx(Animation, {}),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text",
                                children: context.loc('Loading')
                            })
                        ]
                    })
                });
            }
        }
        if (isEmbedded && this.filteredData.length === 0) {
            return /*#__PURE__*/ _jsx("div", {
                className: "filteredGalleryContainer",
                children: this.getNoContentUI()
            });
        }
        if (((_this_filteredData = this.filteredData) === null || _this_filteredData === void 0 ? void 0 : _this_filteredData.length) === 0) {
            var _getWindow_location, _getWindow;
            const { searchText, isSelectedFilters, entityType, changeSearchText, isConverged } = this.props;
            return /*#__PURE__*/ _jsx(NoSearchResults, {
                context: this.context,
                isSearch: !!searchText,
                isFilter: isSelectedFilters,
                entityType: entityType,
                currentPage: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href,
                changeSearchText: changeSearchText,
                isConverged: isConverged
            });
        }
        // DOES SPZA_CONTROLS DIV NEED TO BE HERE?
        return /*#__PURE__*/ _jsxs("div", {
            className: "filteredGalleryContainer",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    id: "pagechange_id"
                }),
                this.getTiles(),
                /*#__PURE__*/ _jsx(PaginationControl, {
                    query: query,
                    galleryPage: this.galleryPage,
                    maxPages: this.maxPages,
                    entityType: entityType
                })
            ]
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0), _define_property(this, "filteredData", []), _define_property(this, "galleryPage", 0), _define_property(this, "maxPages", 0), _define_property(this, "defaultPageSize", !this.props.isMobile ? Constants.FilteredGallery.pageSize : 10);
    }
}
export { AppSourceFilteredGallery as default };
AppSourceFilteredGallery.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func
};
